const quizQuestionTypes = {
    FILL_BLANKS: 'FILL_BLANKS',
};

export default quizQuestionTypes;
